import { Injectable, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmModalContent } from '@core/modal/modal.service';
import { Action, Store } from '@ngrx/store';
import { DialogComponent, DialogService, IDialogConfig, NotificationType } from '@ra-web-tech-ui-toolkit/components';
import { AppState } from '../lemans-app.model';
import { closeAllOpenDialogs, openCatalogDialog, openWebTechDialog } from './modal.action';
@Injectable({
  providedIn: 'root',
})
export class ModalFacade {
  private readonly store$ = inject<Store<AppState>>(Store);
  private readonly dialogService = inject(DialogService);


  openCatalogDialog(content: ConfirmModalContent): void {
    this.store$.dispatch(openCatalogDialog({ payload: content }));
  }

  openWebTechDialog(dialogConfig: {
    config: IDialogConfig;
    type?: NotificationType;
    mainBtnHandler?: () => void;
    closeHandler?: Action;
  }): void {
    this.store$.dispatch(openWebTechDialog(dialogConfig));
  }

  openDialog(config: IDialogConfig, type?: NotificationType): MatDialogRef<DialogComponent> {
    switch (type) {
      case NotificationType.Success:
        return this.dialogService.openSuccessDialog(config);
      case NotificationType.Info:
        return this.dialogService.openInfoDialog(config);
      case NotificationType.Warning:
        return this.dialogService.openWarningDialog(config);
      case NotificationType.Error:
        return this.dialogService.openErrorDialog(config);
      default:
        return this.dialogService.openDialog(config);
    }
  }

  closeAllOpenDialogs(): void {
    this.store$.dispatch(closeAllOpenDialogs());
  }
}
